import { PayloadProps, PutPayloadProps } from "src/models/service.models";

import API_URL from "./apiConfig/api.config";
import apiCall from "./apiConfig/apiCall.config";

export async function addSpecialitySkill(data: PayloadProps) {
  return await apiCall.post(
    API_URL.CATEGORY_MANAGEMENT.SPECIALITY_SKILL.ADD_SPECIALITY_SKILL,
    data
  );
}
export async function getSpecialitySkill() {
  return await apiCall.get(
    API_URL.CATEGORY_MANAGEMENT.SPECIALITY_SKILL.GET_SPECIALITY_SKILL_LIST
  );
}
export async function editSpecialitySkill(
  params: string,
  data: PutPayloadProps
) {
  return await apiCall.put(
    API_URL.CATEGORY_MANAGEMENT.SPECIALITY_SKILL.PUT_SPECIALITY_SKILL + params,
    data
  );
}
export async function deleteSpecialitySkill(params: string) {
  return await apiCall.remove(
    API_URL.CATEGORY_MANAGEMENT.SPECIALITY_SKILL.PUT_SPECIALITY_SKILL + params
  );
}
